(function (root) {
  'use strict';
  const events = new Set(['start', 'question_view', 'answer', 'complete', 'product_click', 'add_to_cart', 'email_requested']);
  function allowed() { try { return root.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true; } catch (_) { return false; } }
  function track(name, details = {}) {
    if (!events.has(name) || !allowed()) return false;
    const data = { quiz_version: 'v2' };
    for (const key of ['run_id','resumed','question','position','value','product_id','variant_id','product_ids','preferences','result_count']) if (details[key] !== undefined) data[key] = details[key];
    try { return root.Shopify?.analytics?.publish('dalstrong_knife_finder_' + name, data) || false; } catch (_) { return false; }
  }
  if (root.Shopify?.loadFeatures && !root.Shopify.customerPrivacy) root.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => {});
  const api = { track, allowed };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.DalstrongKnifeFinderV2Analytics = api;
})(typeof window !== 'undefined' ? window : globalThis);
